<template>
    <div id="report-overall">
        <div class="overall-content">
            <div class="chart-container">
                <div class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon sessions-icon">
                            <md-icon>chat_bubble_outline</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t('report.sessionsOverall') }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.sessionsOverallDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <OverallChatCountChart :filters="filters" />
                    </div>
                </div>

                <div class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon rating-icon">
                            <md-icon>star_outline</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t("report.ratingOverall") }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.ratingOverallDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <OverallRatingChart :filters="filters" />
                    </div>
                </div>

                <div class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon duration-icon">
                            <md-icon>timer</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t('report.sessionDurationOverall') }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.sessionDurationOverallDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <OverallSessionDurationChart :filters="filters" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import OverallChatCountChart from "./OverallChatCountChart.vue";
import OverallRatingChart from "./OverallRatingChart.vue";
import OverallSessionDurationChart from "./OverallSessionDurationChart.vue";
import moment from "moment";

export default {
    name: "Overall",
    components: {
        OverallChatCountChart,
        OverallRatingChart,
        OverallSessionDurationChart,
    },
    props: {
        loading: {
            type: Boolean,
            default: true,
        },
        filters: {
            type: Object,
            default: () => ({
                users: [],
                channels: [],
                startDate: moment().startOf("day").toISOString(),
                endDate: moment().endOf("day").toISOString(),
            }),
        },
    },
};
</script>
<style lang="scss" scoped>
#report-overall {
    width: 100%;
    height: auto;
    min-height: 100vh;
    display: flex;

    .overall-content {
        padding: 16px;
        display: flex;
        flex-direction: column;
        background: var(--color-bg-neutral, #f5f5f5);
        width: 100%;
        min-height: 100vh;

        .chart-container {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 24px;

            .report-card {
                background: #fff;
                border-radius: 12px;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06);
                overflow: hidden;
                transition: box-shadow 0.2s ease;

                &:hover {
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06);
                }

                .report-card-header {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    padding: 20px 24px;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.06);

                    .report-card-icon {
                        width: 44px;
                        height: 44px;
                        border-radius: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;

                        i {
                            font-size: 22px !important;
                            color: #fff;
                        }

                        &.sessions-icon {
                            background: linear-gradient(135deg, #3b82f6, #2563eb);
                        }

                        &.rating-icon {
                            background: linear-gradient(135deg, #f59e0b, #d97706);
                        }

                        &.duration-icon {
                            background: linear-gradient(135deg, #a855f7, #7c3aed);
                        }
                    }

                    .report-card-title {
                        h2 {
                            font-size: 18px;
                            font-weight: 600;
                            margin: 0;
                            color: #1a1a1a;
                        }

                        .report-card-subtitle {
                            font-size: 13px;
                            color: #6b7280;
                            margin: 2px 0 0 0;
                        }
                    }
                }

                .report-card-body {
                    padding: 20px 24px;
                }
            }
        }
    }
}
</style>